const encoder = new TextEncoder();
const decoder = new TextDecoder();

function bytesToUrlBase64(bytes) {
  return btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

function urlBase64ToBytes(base64) {
  const padded = base64
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(Math.ceil(base64.length / 4) * 4, '=');
  return Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
}

async function deriveKey(secret) {
  var hashed = await crypto.subtle.digest('SHA-256', encoder.encode(secret));
  return crypto.subtle.importKey('raw', hashed, { name: 'AES-GCM' }, false, ['encrypt', 'decrypt']);
}

async function encryptMessage(plaintext, passphrase) {
  const key = await deriveKey(passphrase);
  const iv = crypto.getRandomValues(new Uint8Array(12));

  const ciphertext = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, encoder.encode(plaintext));

  return {
    iv: bytesToUrlBase64(iv),
    data: bytesToUrlBase64(new Uint8Array(ciphertext)),
  };
}

async function decryptMessage(encryptedData, passphrase) {
  const key = await deriveKey(passphrase);
  const iv = urlBase64ToBytes(encryptedData.iv);
  const data = urlBase64ToBytes(encryptedData.data);

  const decrypted = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, key, data);
  return decoder.decode(decrypted);
}
async function decryptTokenPayload(encodedPayload, passphrase) {
  const jsonStr = atob(decodeURIComponent(encodedPayload));
  const encryptedPayload = JSON.parse(jsonStr);
  const accessToken = await decryptMessage(encryptedPayload.access_token, passphrase);
  const refreshToken = await decryptMessage(encryptedPayload.refresh_token, passphrase);
  const expiresInStr = await decryptMessage(encryptedPayload.expires_in, passphrase);

  return {
    accessToken,
    refreshToken,
    expiresIn: Number(expiresInStr), // convert back to number
  };
}

export { decryptTokenPayload };
